import { render, staticRenderFns } from "./cityCompany.vue?vue&type=template&id=7023dd20&scoped=true"
import script from "./cityCompany.vue?vue&type=script&lang=js"
export * from "./cityCompany.vue?vue&type=script&lang=js"
import style0 from "./cityCompany.vue?vue&type=style&index=0&id=7023dd20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7023dd20",
  null
  
)

export default component.exports